/**
 * DriverIcon — sanitized from `assets/newSvg/driver.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function DriverIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M14,3 C15.1046,3 16,3.89543 16,5 L19,5 C20.1046,5 21,5.89543 21,7 L21,9 C21,9.93531 20.358,10.7207 19.4906,10.9394 L21.9191,16.6061 L21.9191,16.6061 C21.9971667,16.7881667 22.0071,16.9947222 22.0050481,17.1988926 L22,17.5 L22,17.5 C22,19.433 20.433,21 18.5,21 C17.1038,21 15.8985,20.1825 15.3368,19 L9.66318,19 C9.10145,20.1825 7.8962,21 6.5,21 C4.73655,21 3.2777,19.6958 3.03536,17.9994 L3,18 L3,18 C2.44772,18 2,17.5523 2,17 L2,9 C2,7.89543 2.89543,7 4,7 L8,7 C9.10457,7 10,7.89543 10,9 L10,11 C10,12.1046 10.8954,13 12,13 C13.1046,13 14,12.1046 14,11 L14,5 L12,5 C11.4477,5 11,4.55228 11,4 C11,3.44772 11.4477,3 12,3 L14,3 Z M6.5,16 C5.67157,16 5,16.6716 5,17.5 C5,18.3284 5.67157,19 6.5,19 C7.32843,19 8,18.3284 8,17.5 C8,16.6716 7.32843,16 6.5,16 Z M18.5,16 C17.6716,16 17,16.6716 17,17.5 C17,18.3284 17.6716,19 18.5,19 C19.3284,19 20,18.3284 20,17.5 C20,16.7037 19.2985,16 18.5,16 Z M8,9 L4,9 L4,11 L8,11 L8,9 Z M19,7 L16,7 L16,9 L19,9 L19,7 Z"
        fillRule="nonzero"
        fill={color}
      />
    </Svg>
  );
}

export default DriverIcon;
